import React, { Fragment, useEffect, useState } from 'react';
import {
   Box,
   Typography,
   Radio,
   Switch,
   Chip,
   Button,
   InputAdornment,
   FormGroup,
   FormControlLabel,
   Checkbox,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
   AlertLabel,
   Input,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import { TitleLabel, LabelInputSpin } from '../../Element/LabelInputForm';
import { Controller, useForm } from 'react-hook-form';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import ReactQuill from 'react-quill';
import SearchEmployee from '../../Search/SearchEmployee';
import SearchRuleSurvey from '../../Search/SearchRuleSurvey';
import SearchDivision from '../../Search/SearchDivision';
import SearchReward from '../../Search/SearchReward';
import SwitchIOS from '../../Switch/SwitchIOS';
import ImageUpload from './component/ImageUpload';

// import ErrorPopup from "../../Error/ErrorPopup";
import dayjs from 'dayjs';
import { GoogleAddressLookup } from 'react-rainbow-components';
import { isObject } from '../../../configs/helpers/utility';
import { color } from 'echarts';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      width: '80%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      backgroundColor: '#F2F4FA',
   },
   paperDark: {
      width: '80%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
      backgroundColor: '#424242',
   },
   header: {
      padding: theme.spacing(2, 4, 3),
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   title_name: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 2),
      marginBottom: '20px',
   },
   category: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 0),
      margin: '0 24px 30px',
      borderRadius: '0 0 8px 8px',
      fontFamily: 'DBHeavent',
      fontSize: '20px',
   },
   activeLineCategory: {
      height: '5px',
      width: '150px',
      backgroundColor: '#ed008a',
   },
   inActivelineCategory: {
      height: '5px',
      width: '150px',
   },
   image_banner: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 2),
      margin: '0 24px 30px',
      borderRadius: '8px',
      fontFamily: 'DBHeavent',
      fontSize: '20px',
   },
   type_privilege: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 4, 2),
      margin: '0 24px 10px',
      borderRadius: '8px',
      fontFamily: 'DBHeavent',
      fontSize: '20px',
   },
   require: {
      display: 'inline-block',
      color: 'red',
      marginLeft: '3px',
   },
}));

const InformationComponent = ({
   onInformationData,
   onDetailSurveyData,
   // onInformationInitial,
}) => {
   const classes = useStyles();
   const theme = useTheme();

   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         startDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date().getHours(),
            new Date().getMinutes(),
         ),
         // endDate: new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),new Date().getHours(),new Date().getMinutes())
      },
   });

   const [surveyDetailInformationData, setSurveyDetailInformationData] =
      useState(null);

   const [formInformation, setFormInformation] = useState({
      // tabQuestion: false,
      isDisplay: false,
      isActive: false,
      coverImage: null,
      typeReward: 'no_reward',
      privilegePoint: {
         governance: 0,
         digitalization: 0,
         society: 0,
      },
      namePrivilege: '',
      nameTitleSurvey: '',
      descSurvey: null | '',
      initialPoints: 0,
      reward: {
         rewardId: 0,
         rewardText: '',
      },
      limitPoint: {
         isLimitPoint: false,
         limitPoint: 0,
      },
      limitRespondent: {
         isLimitRespondent: false,
         limitRespondent: 0,
      },
      permissionLimit: {
         governance: 0,
         digitalization: 0,
         society: 0,
      },
      OwnerOrgEmployeeId: null,
      rule: {
         ruleId: '',
         ruleNameTh: '',
         ruleNameEn: '',
      },
      startDate: '',
      endDate: '',
      whiteListDivisions: [],
      blackListDivisions: [],
      deliveryType: [],
      useLocation: false,
      useLocationMode: '',
      location: '',
      latitude: '',
      longitude: '',
   });

   const [dataModel, setDataModel] = useState({
      orgOwner: [],
      whitelistDivisions: [],
      blacklistDivisions: [],
   });

   const optionRewardDefault = [
      {
         value: surveyDetailInformationData?.surveyGroup.rewardId,
         label: surveyDetailInformationData?.surveyGroup.rewardNameTh,
      },
   ];

   const handleUploadeChange = (file) => {
      setFormInformation((o) => ({
         ...o,
         coverImage: file.url,
      }));
   };

   const handleTypeReward = (e) => {
      setFormInformation((o) => ({
         ...o,
         typeReward: e.target.value,
      }));
   };

   const handlePrivilegePoint = (key, e) => {
      const inputValue = e.target.value.replace(/,/g, '');
      if (!isNaN(inputValue)) {
         const newValue = parseInt(inputValue) || 0;

         setFormInformation((o) => ({
            ...o,
            privilegePoint: {
               ...formInformation.privilegePoint,
               [key]: newValue,
            },
         }));
      }
   };

   const handleInputNamePrivilege = (e) => {
      e.persist();

      setFormInformation((o) => ({
         ...o,
         namePrivilege: e.target.value,
      }));
   };

   const handleInputTitleSurvey = (e) => {
      e.persist();

      setFormInformation((o) => ({
         ...o,
         nameTitleSurvey: e.target?.value || '',
      }));
   };

   const handleDescSurvey = (e) => {
      setFormInformation((o) => ({
         ...o,
         descSurvey: e || '',
      }));
   };

   const handleInitialPoints = (e) => {
      const inputValue = e.target.value.replace(/,/g, '');

      // อนุญาตให้พิมพ์ค่าใดๆ ได้ระหว่าง focus
      if (!isNaN(inputValue)) {
         const numericValue = parseInt(inputValue) || 0;
         setFormInformation((o) => ({
            ...o,
            initialPoints: numericValue,
         }));
      }
   };

   const handleInitialPointsBlur = (e) => {
      const currentValue = formInformation.initialPoints;
      const permissionLimitsSum = Object.values(
         formInformation.permissionLimit,
      ).reduce((sum, val) => sum + val, 0);

      // ถ้าค่าปัจจุบันน้อยกว่าผลรวม ให้ปรับเป็นเท่ากับผลรวม
      if (currentValue < permissionLimitsSum) {
         setFormInformation((o) => ({
            ...o,
            initialPoints: permissionLimitsSum,
         }));
      }
   };

   const handleReward = (e) => {
      setFormInformation((o) => ({
         ...o,
         reward: {
            rewardId: e?.data?.rewardId ?? null,
            rewardText: e?.data?.rewardTh ?? '',
         },
      }));
   };

   const handleSwitchPoint = (key) => (event) => {
      const isChecked = event.target.checked;

      setFormInformation((o) => ({
         ...o,
         limitPoint: {
            isLimitPoint: key === 'limit_points' ? isChecked : !isChecked,
         },
      }));
   };

   const handleSwitchRespondent = (key) => (event) => {
      const isChecked = event.target.checked;

      setFormInformation((o) => ({
         ...o,

         limitRespondent: {
            isLimitRespondent:
               key === 'limit_respondent' ? isChecked : !isChecked,
         },
      }));
   };

   const handleSwitchIsDisplay = (newCheckedValue) => {
      setFormInformation((o) => ({
         ...o,
         isDisplay: newCheckedValue,
      }));
   };

   const handleLimit = (key, value) => {
      setFormInformation((prev) => {
         if (key === 'point') {
            // ตรวจสอบเงื่อนไขก่อนอัปเดต limitPoint
            if (!prev.limitPoint.isLimitPoint) {
               return prev; // หากไม่อนุญาตให้แก้ไข limitPoint ให้คืนค่าตัวเดิม
            }
            return {
               ...prev,
               limitPoint: {
                  ...prev.limitPoint,
                  limitPoint: value ? value : 0, // อัปเดตค่า limitPoint
               },
            };
         } else if (key === 'respondent') {
            // ตรวจสอบเงื่อนไขก่อนอัปเดต limitRespondent
            if (!prev.limitRespondent.isLimitRespondent) {
               return prev; // หากไม่อนุญาตให้แก้ไข limitRespondent ให้คืนค่าตัวเดิม
            }
            return {
               ...prev,
               limitRespondent: {
                  ...prev.limitRespondent,
                  limitRespondent: value ? value : 0, // อัปเดตค่า limitRespondent
               },
            };
         }
         return prev; // คืนค่าตัวเดิมหาก key ไม่ตรง
      });
   };

   const handlePermissionLimit = (key, e) => {
      const inputValue = e.target.value.replace(/,/g, '');
      if (!isNaN(inputValue)) {
         // คำนวณผลรวมใหม่
         const newSum = Object.values({
            ...formInformation.permissionLimit,
            [key]: parseInt(inputValue) || 0,
         }).reduce((sum, val) => sum + val, 0);

         setFormInformation((o) => ({
            ...o,
            permissionLimit: {
               ...o.permissionLimit,
               [key]: parseInt(inputValue) || 0,
            },
            initialPoints:
               newSum === 0
                  ? 0
                  : newSum > o.initialPoints
                  ? newSum
                  : o.initialPoints,
         }));
      }
   };

   const handleRule = (select) => {
      setFormInformation((o) => ({
         ...o,
         rule: {
            ruleId: select?.data?.ruleId ?? null,
            ruleNameTh: select?.data?.ruleNameTh ?? '',
            ruleNameEn: select?.data?.ruleNameEn ?? '',
         },
      }));
   };

   const handleDelete = (name, value) => (e) => {
      let arrayObj = dataModel[name];

      let removeIndex = arrayObj
         .map((item) => {
            return item.value;
         })
         .indexOf(value);

      if (removeIndex !== -1) {
         arrayObj.splice(removeIndex, 1);
         setDataModel((prevState) => ({ ...prevState, [name]: arrayObj }));
         if (name === 'orgOwner') {
            setFormInformation((o) => ({
               ...o,
               OwnerOrgEmployeeId: null,
            }));
         } else if (name === 'whitelistDivisions') {
            setFormInformation((o) => ({
               ...o,
               whiteListDivisions: o.whiteListDivisions.filter(
                  (id) => id.divisionId !== value,
               ),
            }));
         } else if (name === 'blacklistDivisions') {
            setFormInformation((o) => ({
               ...o,
               blackListDivisions: o.blackListDivisions.filter(
                  (id) => id.divisionId !== value,
               ),
            }));
         }
      }
   };

   const handleAdd = (name) => (e) => {
      let arrayObj = dataModel[name];
      if (
         name === 'affordableOrgEmployee' &&
         dataModel.affordableOrgEmployee.length === 5
      ) {
         return false;
      } else if (name === 'orgOwner' && dataModel.orgOwner.length === 1) {
         return false;
      } else {
         if (e) {
            let data = { label: e.label, value: e.value };

            if (name === 'orgOwner') {
               setFormInformation((o) => ({
                  ...o,
                  OwnerOrgEmployeeId: data.value,
               }));
            } else if (name === 'whitelistDivisions') {
               setFormInformation((o) => ({
                  ...o,
                  whiteListDivisions: [
                     ...(o.whiteListDivisions || []),
                     { divisionId: data.value },
                  ],
               }));
            } else if (name === 'blacklistDivisions') {
               setFormInformation((o) => ({
                  ...o,
                  blackListDivisions: [
                     ...(o.blackListDivisions || []),
                     { divisionId: data.value },
                  ],
               }));
            }
            arrayObj.push(data);

            setDataModel((prevState) => ({ ...prevState, [name]: arrayObj }));
         }
      }
   };

   const handleSurveyChange = (newCheckedValue) => {
      setFormInformation((o) => ({
         ...o,
         isActive: newCheckedValue,
      }));
   };

   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');

   const handleStartDateChange = (e) => {
      setFormInformation((o) => ({
         ...o,
         startDate: dayjs(e).format('YYYY-MM-DDTHH:mm:ss'),
      }));

      setValue('startDate', e);
   };

   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') {
         setFormInformation((o) => ({
            ...o,
            endDate: dayjs(endOfDay(e)).format('YYYY-MM-DDTHH:mm:ss'),
         }));
         setValue('endDate', endOfDay(e));
      } else {
         setFormInformation((o) => ({
            ...o,
            endDate: dayjs(e).format('YYYY-MM-DDTHH:mm:ss'),
         }));
         setValue('endDate', e);
      }
   };

   const handleDeliveryTypeChange = (event, value) => {
      const updatedDeliveryType = event.target.checked
         ? [...formInformation.deliveryType, value]
         : formInformation.deliveryType.filter((item) => item !== value);

      setFormInformation((prev) => ({
         ...prev,
         deliveryType: updatedDeliveryType,
      }));
   };

   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });

   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });

   useEffect(() => {
      if (onDetailSurveyData) {
         setSurveyDetailInformationData(onDetailSurveyData);
      }
   }, [onDetailSurveyData]);

   useEffect(() => {
      if (surveyDetailInformationData?.surveyGroup) {
         const formattedStartDate = surveyDetailInformationData?.surveyGroup
            .validFrom
            ? new Date(surveyDetailInformationData?.surveyGroup.validFrom)
            : null;

         const formattedEndDate = surveyDetailInformationData?.surveyGroup
            .validThrough
            ? new Date(surveyDetailInformationData?.surveyGroup.validThrough)
            : null;

         setFormInformation((prevState) => ({
            ...prevState,
            isDisplay: surveyDetailInformationData?.surveyGroup?.isDisplay
               ? true
               : false,
            isActive:
               surveyDetailInformationData?.surveyGroup.status == 2
                  ? false
                  : true,
            coverImage: surveyDetailInformationData?.surveyGroup.imageUrl || '',
            typeReward:
               surveyDetailInformationData?.surveyGroup.rewardType === 0
                  ? 'no_reward'
                  : surveyDetailInformationData?.surveyGroup.rewardType === 1
                  ? 'point'
                  : 'reward',
            privilegePoint: {
               governance: surveyDetailInformationData?.surveyGroup.gPoint || 0,
               digitalization:
                  surveyDetailInformationData?.surveyGroup.sPoint || 0,
               society: surveyDetailInformationData?.surveyGroup.bPoint || 0,
            },
            namePrivilege:
               surveyDetailInformationData?.surveyGroup.rewardText || '',
            nameTitleSurvey:
               surveyDetailInformationData?.surveyGroup.surveySubNameTh || '',
            descSurvey:
               surveyDetailInformationData?.surveyGroup.surveyDescTh || '',
            initialPoints:
               surveyDetailInformationData?.surveyGroup.initialPoints || 0,
            limitPoint: {
               isLimitPoint:
                  surveyDetailInformationData?.surveyGroup.rewardType === 1
                     ? surveyDetailInformationData?.surveyGroup.isPointLimit ||
                       false
                     : surveyDetailInformationData?.surveyGroup.isRewardLimit ||
                       false,
               limitPoint:
                  surveyDetailInformationData?.surveyGroup.rewardLimit || 0,
            },
            limitRespondent: {
               isLimitRespondent:
                  surveyDetailInformationData?.surveyGroup.isParticipateLimit ||
                  false,
               limitRespondent:
                  surveyDetailInformationData?.surveyGroup.participateLimit ||
                  0,
            },
            reward: {
               rewardId: surveyDetailInformationData?.surveyGroup.rewardId,
               rewardText:
                  surveyDetailInformationData?.surveyGroup.rewardNameTh,
            },
            permissionLimit: {
               governance:
                  surveyDetailInformationData?.surveyGroup.gPointLimit || 0,
               digitalization:
                  surveyDetailInformationData?.surveyGroup.sPointLimit || 0,
               society:
                  surveyDetailInformationData?.surveyGroup.bPointLimit || 0,
            },
            OwnerOrgEmployeeId:
               surveyDetailInformationData?.surveyGroup.ownerOrgEmployeeId,
            rule: {
               ruleId: surveyDetailInformationData?.surveyGroup.ruleId,
               ruleCode: surveyDetailInformationData?.surveyGroup.ruleCode,
               ruleNameTh: surveyDetailInformationData?.surveyGroup.ruleNameTh,
            },
            whiteListDivisions:
               surveyDetailInformationData?.allowList.whiteList?.map(
                  (item) => ({
                     divisionId: item.divisionId,
                     surveyAllowListId: item.surveyAllowListId,
                  }),
               ) || [],
            blackListDivisions:
               surveyDetailInformationData?.allowList.blackList?.map(
                  (item) => ({
                     divisionId: item.divisionId,
                     surveyAllowListId: item.surveyAllowListId,
                  }),
               ) || [],

            startDate: formattedStartDate,
            endDate: formattedEndDate,
            deliveryType:
               surveyDetailInformationData?.surveyGroup.deliveryType.map(
                  (e) => e.deliveryTypeId,
               ),
            useLocation: surveyDetailInformationData?.surveyGroup.useLocation,
            useLocationMode: String(
               surveyDetailInformationData?.surveyGroup.useLocationMode,
            ),
            location: surveyDetailInformationData?.surveyGroup.venueTh,
            latitude: surveyDetailInformationData?.surveyGroup.latitude,
            longitude: surveyDetailInformationData?.surveyGroup.longitude,
         }));

         // Set form values for react-hook-form
         if (formattedStartDate) {
            setValue('startDate', formattedStartDate);
         }
         if (formattedEndDate) {
            setValue('endDate', formattedEndDate);
         }
      }
   }, [surveyDetailInformationData, setValue]);

   useEffect(() => {
      onInformationData(formInformation);
   }, [formInformation]);

   useEffect(() => {
      if (
         surveyDetailInformationData?.allowList.whiteList ||
         surveyDetailInformationData?.allowList.blackList
      ) {
         if (
            surveyDetailInformationData?.allowList.whiteList ||
            surveyDetailInformationData?.allowList.blackList
         ) {
         }
         setDataModel({
            orgOwner: [
               {
                  value: surveyDetailInformationData?.surveyGroup
                     .ownerOrgEmployeeId,
                  label: `${surveyDetailInformationData?.surveyGroup.ownerOrgEmployeeId} ${surveyDetailInformationData?.surveyGroup.ownerOrgEmployeeDesc}`,
               },
            ],
            whitelistDivisions: surveyDetailInformationData?.allowList.whiteList
               ? surveyDetailInformationData?.allowList.whiteList.map(
                    (value) => ({
                       label: value.divisionDesc,
                       value: value.divisionId,
                    }),
                 )
               : [],
            blacklistDivisions: surveyDetailInformationData?.allowList.blackList
               ? surveyDetailInformationData?.allowList.blackList.map(
                    (value) => ({
                       label: value.divisionDesc,
                       value: value.divisionId,
                    }),
                 )
               : [],
         });
      }
   }, [surveyDetailInformationData]);

   useEffect(() => {
      register({ name: 'startDate' }, { required: true });
      register({ name: 'endDate' }, { required: true });
   }, [register]);

   useEffect(() => {
      const defaultDate = new Date(
         new Date().getFullYear(),
         new Date().getMonth(),
         new Date().getDate(),
         new Date().getHours(),
         new Date().getMinutes(),
      );

      setFormInformation((prevState) => ({
         ...prevState,
         startDate: dayjs(defaultDate).format('YYYY-MM-DDTHH:mm:ss'),
      }));
   }, []);

   const queryParams = new URLSearchParams(window.location.search);
   const surveyGroupId = queryParams.get('SurveyGroupId');

   const handleLocation = (e) => {
      if (isObject(e)) {
         setFormInformation((o) => ({
            ...o,
            location: e,
            latitude: e.geometry.location.lat(),
            longitude: e.geometry.location.lng(),
         }));
      } else
         setFormInformation((o) => ({
            ...o,
            location: null,
         }));
   };

   const handleUseLocation = (e) => {
      setFormInformation((o) => ({
         ...o,
         useLocation: e?.target?.checked,
      }));
   };

   const handleLocationMode = (e) => {
      setFormInformation((o) => ({
         ...o,
         useLocationMode: e.target.value,
      }));
   };

   const handleLatitude = (e) => {
      const value = e.target.value;
      if (value === '' || /^-?\d*(\.\d*)?$/.test(value)) {
         setFormInformation((o) => ({
            ...o,
            latitude: value,
         }));
      }
   };

   const handleLongitude = (e) => {
      const value = e.target.value;
      if (value === '' || /^-?\d*(\.\d*)?$/.test(value)) {
         setFormInformation((o) => ({
            ...o,
            longitude: value,
         }));
      }
   };

   const sixDecimalOrIntegerRegex = /(^-?\d+$)|(^-?\d+\.\d{6,}$)/;

   return (
      <div className={classes.containerPaper}>
         {/* รูป Banner */}
         <div className={classes.image_banner}>
            <Box color={theme.palette.type === 'dark' ? 'black' : 'black'}>
               Cover Banner (ขนาดรูปภาพ 1:1){' '}
               <div className={classes.require}>*</div>
            </Box>

            <ImageUpload
               id='image-upload'
               width='300px'
               height='300px'
               imageUrl={formInformation.coverImage}
               onUploadChange={handleUploadeChange}
            />
         </div>

         {/* การแสดงผล */}
         <div className={classes.type_privilege}>
            <Box display={'flex'} marginTop={'5px'}>
               <Switch
                  checked={formInformation.isDisplay}
                  onChange={() => {
                     setFormInformation((o) => ({
                        ...o,
                        isDisplay: !formInformation.isDisplay,
                     }));
                  }}
               />
               <Box
                  display={'flex'}
                  flexDirection={'column'}
                  padding={'5px 0 0'}
               >
                  <Box fontWeight={'bold'}>แสดงผลบน Web App</Box>
               </Box>
            </Box>
         </div>

         {/* ประเภทของรางวัล */}
         <div className={classes.type_privilege}>
            <Box color={theme.palette.type === 'dark' ? 'black' : 'black'}>
               ประเภทการให้รางวัล
            </Box>
            <Box display={'flex'}>
               <Box display={'flex'} alignItems={'center'}>
                  <Radio
                     checked={formInformation.typeReward === 'no_reward'}
                     onChange={handleTypeReward}
                     value='no_reward'
                     name='radio-button-demo'
                     inputProps={{ 'aria-label': 'No Reward' }}
                     disabled={surveyDetailInformationData}
                  />
                  <Typography>ไม่ได้รางวัล</Typography>
               </Box>
               <Box display={'flex'} alignItems={'center'}>
                  <Radio
                     checked={formInformation.typeReward === 'point'}
                     onChange={handleTypeReward}
                     value='point'
                     name='radio-button-demo'
                     inputProps={{ 'aria-label': 'Point' }}
                     disabled={surveyDetailInformationData}
                  />
                  <Typography>คะแนน</Typography>
               </Box>
               <Box display={'flex'} alignItems={'center'}>
                  <Radio
                     checked={formInformation.typeReward === 'reward'}
                     onChange={handleTypeReward}
                     value='reward'
                     name='radio-button-demo'
                     inputProps={{ 'aria-label': 'Reward' }}
                     disabled={surveyDetailInformationData}
                  />
                  <Typography>ของรางวัล</Typography>
               </Box>

               {/* <div>{rewardType}</div> */}
            </Box>
         </div>

         {/* กำหนดการให้คะแนน */}
         {formInformation.typeReward === 'point' && (
            <div className={classes.type_privilege}>
               <TitleLabel>กำหนดการให้คะแนน</TitleLabel>
               <Box display={'flex'} alignItems={'center'}>
                  <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                     <Box fontWeight={'bold'}>ตอบครบทุกข้อ เพื่อรับคะแนน</Box>
                     <Box>
                        <Box>
                           ผู้ตอบแบบสำรวจจะต้องตอบคำถามให้ครบข้อ
                           เพื่อได้รับคะแนน
                        </Box>
                     </Box>
                  </Box>

                  <Box
                     display={'flex'}
                     flexDirection={'column'}
                     gridGap={'10px'}
                     width={'100%'}
                  >
                     <Box>
                        <TitleLabel>for SOCIETY</TitleLabel>
                        <TextFieldCustom
                           textAlign={'right'}
                           width={'40%'}
                           placeholder={'B'}
                           variant={'outlined'}
                           size={'small'}
                           InputProps={{
                              startAdornment: (
                                 <InputAdornment position={'start'}>
                                    B
                                 </InputAdornment>
                              ),
                           }}
                           value={formInformation.privilegePoint.society.toLocaleString()}
                           onChange={(value) =>
                              handlePrivilegePoint('society', value)
                           }
                           disabled={surveyDetailInformationData}
                        />
                     </Box>

                     <Box>
                        <TitleLabel>with GOVERNANCE</TitleLabel>
                        <TextFieldCustom
                           textAlign={'right'}
                           width={'40%'}
                           placeholder={'G'}
                           variant={'outlined'}
                           size={'small'}
                           InputProps={{
                              startAdornment: (
                                 <InputAdornment position={'start'}>
                                    G
                                 </InputAdornment>
                              ),
                           }}
                           value={formInformation.privilegePoint.governance.toLocaleString()}
                           onChange={(value) =>
                              handlePrivilegePoint('governance', value)
                           }
                           disabled={surveyDetailInformationData}
                        />
                     </Box>

                     <Box>
                        <TitleLabel>through DIGITALIZATION</TitleLabel>
                        <TextFieldCustom
                           textAlign={'right'}
                           width={'40%'}
                           placeholder={'S'}
                           variant={'outlined'}
                           size={'small'}
                           InputProps={{
                              startAdornment: (
                                 <InputAdornment position={'start'}>
                                    S
                                 </InputAdornment>
                              ),
                           }}
                           value={formInformation.privilegePoint.digitalization.toLocaleString()}
                           onChange={(value) =>
                              handlePrivilegePoint('digitalization', value)
                           }
                           disabled={surveyDetailInformationData}
                        />
                     </Box>
                  </Box>
               </Box>
            </div>
         )}

         {/* ชื่อหน้าหลักแบบสอบถาม รายละเอียดแบบสอบถาม การจำกัด */}
         <div className={classes.type_privilege}>
            {formInformation.typeReward === 'reward' && (
               <Box marginBottom={'18px'}>
                  <TitleLabel>
                     ข้อความแสดงหลังตอบแบบสอบถาม
                     {errors.namePrivilege && (
                        <AlertLabel>
                           กรุณาระบุข้อความแสดงรางวัลหน้าหลักแบบสอบถาม
                        </AlertLabel>
                     )}
                  </TitleLabel>
                  <Input
                     name={'namePrivilege'}
                     placeholder={'ข้อความแสดงรางวัลหน้าหลักแบบสอบถาม'}
                     // ref={register({ required: true })}
                     value={formInformation.namePrivilege}
                     onChange={handleInputNamePrivilege}
                  />
               </Box>
            )}

            <TitleLabel>ข้อความแสดงหน้าแรกของแบบสอบถาม</TitleLabel>
            <Input
               name={'nameTitleSurvey'}
               placeholder='ชื่อหน้าหลักแบบสอบถาม'
               value={formInformation.nameTitleSurvey || ''} // ป้องกัน null
               // value={nameTitleSurvey}
               onChange={handleInputTitleSurvey}
            />

            <Box marginTop={'18px'} width={'50%'}>
               <Box display={'flex'} justifyContent={'space-between'}>
                  <TitleLabel>รายละเอียดแบบสอบถาม</TitleLabel>
                  <div
                     style={{
                        color:
                           (formInformation.descSurvey || '').trim().length >
                           4000
                              ? 'red'
                              : 'black',
                     }}
                  >
                     {(formInformation.descSurvey || '').trim().length}/{4000}
                  </div>
               </Box>
               <ReactQuill
                  value={formInformation.descSurvey}
                  onChange={handleDescSurvey}
               />
            </Box>

            {formInformation.typeReward == 'point' && (
               <Box fontWeight={700} marginTop={'16px'}>
                  กำหนดจำนวนคะแนนทั้งแบบสอบถาม&nbsp;&nbsp;
                  <Input
                     name={'initialPoints'}
                     textAlign={'right'}
                     width={'5rem'}
                     value={formInformation.initialPoints.toLocaleString()}
                     onChange={handleInitialPoints}
                     onBlur={handleInitialPointsBlur}
                     disabled={surveyDetailInformationData}
                  />
                  &nbsp;&nbsp;คะแนน
               </Box>
            )}

            {formInformation.typeReward == 'reward' && (
               <Box>
                  <Box
                     display={'flex'}
                     flexDirection={'column'}
                     width={'100%'}
                     margin={'16px 0 10px'}
                  >
                     <Box fontWeight={'bold'}>
                        ตอบครบทุกข้อ เพื่อรับของรางวัล
                     </Box>

                     <Box>
                        ผู้ตอบแบบสอบถามจะต้องตอบคำถามให้ครบข้อ
                        เพื่อได้รับของรางวัล
                     </Box>
                  </Box>

                  <Box width={'100%'}>
                     <TitleLabel>
                        ของรางวัล
                        <div className={classes.require}>*</div>
                     </TitleLabel>

                     <Controller
                        as={
                           <SearchReward
                              placeholder={'เลือกของรางวัล'}
                              closeMenuOnSelect
                              isClearable={true}
                              defaultValue={
                                 surveyDetailInformationData
                                    ? optionRewardDefault[0]
                                    : null
                              }
                           />
                        }
                        onChange={([selected]) => {
                           handleReward(selected);
                        }}
                        name='privilege'
                        control={control}
                     />
                  </Box>
               </Box>
            )}
            {formInformation.typeReward === 'reward' && (
               <Fragment>
                  <Box fontWeight={'bold'} margin={'16px 0 10px'}>
                     ตัวเลือกการรับของรางวัล
                  </Box>
                  <FormGroup row>
                     <FormControlLabel
                        control={
                           <Checkbox
                              checked={formInformation.deliveryType.includes(1)}
                              onChange={(e) => handleDeliveryTypeChange(e, 1)}
                           />
                        }
                        label='รับด้วยตัวเองที่สำนักงานใหญ่'
                     />
                     <FormControlLabel
                        control={
                           <Checkbox
                              checked={formInformation.deliveryType.includes(2)}
                              onChange={(e) => handleDeliveryTypeChange(e, 2)}
                           />
                        }
                        label='รับที่สำนักงานภาค 1 - 18'
                     />
                     <FormControlLabel
                        control={
                           <Checkbox
                              checked={formInformation.deliveryType.includes(3)}
                              onChange={(e) => handleDeliveryTypeChange(e, 3)}
                           />
                        }
                        label='จัดส่งที่บ้าน'
                     />
                  </FormGroup>
               </Fragment>
            )}
            <Box marginTop={'18px'}>
               <Box display={'flex'} alignItems={'center'}>
                  <Box width={'100%'} display={'flex'} flexDirection={'column'}>
                     {(formInformation.typeReward === 'point' ||
                        formInformation.typeReward === 'reward') && (
                        <Box>
                           <Box display={'flex'}>
                              <Switch
                                 checked={
                                    !formInformation.limitPoint.isLimitPoint
                                 }
                                 onChange={handleSwitchPoint('no_limit_points')}
                                 disabled={
                                    surveyDetailInformationData &&
                                    formInformation.typeReward === 'point'
                                 }
                              />
                              <Box
                                 display={'flex'}
                                 flexDirection={'column'}
                                 padding={'5px 0 5px'}
                              >
                                 <Box fontWeight={'bold'}>
                                    {formInformation.typeReward === 'reward'
                                       ? 'ไม่จำกัดจำนวนของรางวัล'
                                       : 'ไม่จำกัดจำนวนคะแนน'}
                                 </Box>
                                 <Box>
                                    {formInformation.typeReward === 'reward'
                                       ? 'สามารถให้ของรางวัลผู้ตอบแบบสอบถามได้ไม่จำกัดจำนวน'
                                       : 'สามารถให้คะแนนผู้ตอบแบบสอบถามได้ไม่จำกัดจำนวน'}
                                 </Box>
                              </Box>
                           </Box>

                           <Box display={'flex'} marginTop={'5px'}>
                              <Switch
                                 checked={
                                    formInformation.limitPoint.isLimitPoint
                                 }
                                 onChange={handleSwitchPoint('limit_points')}
                                 disabled={
                                    surveyDetailInformationData &&
                                    formInformation.typeReward === 'point'
                                 }
                              />
                              <Box display={'flex'} gridGap={'15px'}>
                                 <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                    padding={'5px 0 0'}
                                 >
                                    <Box fontWeight={'bold'}>
                                       {formInformation.typeReward === 'reward'
                                          ? 'จำกัดจำนวนของรางวัล'
                                          : 'จำกัดจำนวนคะแนน'}
                                    </Box>
                                    <Box>
                                       {formInformation.typeReward === 'reward'
                                          ? 'สามารถให้ของรางวัลผู้ตอบแบบสอบถามได้จำกัดจำนวน'
                                          : 'สามารถให้คะแนนผู้ตอบแบบสอบถามได้จำกัดจำนวน'}
                                    </Box>
                                 </Box>
                                 {formInformation.typeReward == 'reward' && (
                                    <Box>
                                       <LabelInputSpin
                                          label=''
                                          value={
                                             formInformation.limitPoint
                                                .limitPoint
                                          }
                                          onChange={(newValue) =>
                                             handleLimit(
                                                'point',
                                                isNaN(newValue) ? 0 : newValue,
                                             )
                                          }
                                       />
                                    </Box>
                                 )}
                              </Box>
                           </Box>
                        </Box>
                     )}

                     <Box display={'flex'} marginTop={'5px'}>
                        <Switch
                           checked={
                              !formInformation.limitRespondent.isLimitRespondent
                           }
                           onChange={handleSwitchRespondent(
                              'no_limit_respondent',
                           )}
                        />
                        <Box
                           display={'flex'}
                           flexDirection={'column'}
                           padding={'5px 0 0'}
                        >
                           <Box fontWeight={'bold'}>
                              ไม่จำกัดจำนวนผู้ตอบแบบสำรวจ
                           </Box>
                           <Box>
                              เปิดให้ผู้ตอบแบบสำรวจสามารถใช้งานได้ไม่จำกัดจำนวน
                           </Box>
                        </Box>
                     </Box>

                     <Box display={'flex'} marginTop={'5px'}>
                        <Switch
                           checked={
                              formInformation.limitRespondent.isLimitRespondent
                           }
                           onChange={handleSwitchRespondent('limit_respondent')}
                        />
                        <Box display={'flex'} gridGap={'15px'}>
                           <Box
                              display={'flex'}
                              flexDirection={'column'}
                              padding={'5px 0 0'}
                           >
                              <Box fontWeight={'bold'}>
                                 จำกัดจำนวนผู้ตอบแบบสำรวจ
                              </Box>
                              <Box>
                                 เปิดให้ผู้ตอบแบบสำรวจสามารถใช้งานได้จำกัดจำนวน
                              </Box>
                           </Box>
                           <Box>
                              <LabelInputSpin
                                 label=''
                                 value={
                                    formInformation.limitRespondent
                                       .limitRespondent
                                 }
                                 onChange={(newValue) =>
                                    handleLimit(
                                       'respondent',
                                       isNaN(newValue) ? 0 : newValue,
                                    )
                                 }
                              />
                           </Box>
                        </Box>
                     </Box>
                  </Box>

                  {formInformation.typeReward === 'point' &&
                     formInformation.limitPoint.isLimitPoint && (
                        <Box
                           width={'100%'}
                           display={'flex'}
                           justifyContent={'center'}
                        >
                           <Box
                              display={'flex'}
                              flexDirection={'column'}
                              gridGap={'10px'}
                           >
                              <Box>
                                 <TitleLabel>for SOCIETY</TitleLabel>
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={"33.33%"}
                                    placeholder={'B'}
                                    variant={'outlined'}
                                    size={'small'}
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position={'start'}>
                                             B
                                          </InputAdornment>
                                       ),
                                    }}
                                    value={formInformation.permissionLimit.society.toLocaleString()}
                                    onChange={(value) =>
                                       handlePermissionLimit('society', value)
                                    }
                                    disabled={surveyDetailInformationData}
                                 />
                              </Box>

                              <Box>
                                 <TitleLabel>with GOVERNANCE</TitleLabel>
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={"33.33%"}
                                    placeholder={'G'}
                                    variant={'outlined'}
                                    size={'small'}
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position={'start'}>
                                             G
                                          </InputAdornment>
                                       ),
                                    }}
                                    value={formInformation.permissionLimit.governance.toLocaleString()}
                                    onChange={(value) =>
                                       handlePermissionLimit(
                                          'governance',
                                          value,
                                       )
                                    }
                                    disabled={surveyDetailInformationData}
                                 />
                              </Box>

                              <Box>
                                 <TitleLabel>through DIGITALIZATION</TitleLabel>
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    // width={"33.33%"}
                                    placeholder={'S'}
                                    variant={'outlined'}
                                    size={'small'}
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position={'start'}>
                                             S
                                          </InputAdornment>
                                       ),
                                    }}
                                    value={formInformation.permissionLimit.digitalization.toLocaleString()}
                                    onChange={(value) =>
                                       handlePermissionLimit(
                                          'digitalization',
                                          value,
                                       )
                                    }
                                    disabled={surveyDetailInformationData}
                                 />
                              </Box>
                           </Box>
                        </Box>
                     )}
               </Box>
            </Box>
         </div>

         <div className={classes.type_privilege}>
            <Box display={'flex'} gridGap={'16px'} marginBottom={'10px'}>
               <Box width={'100%'}>
                  <TitleLabel>
                     เจ้าของแบบสอบถาม
                     <div className={classes.require}>*</div>
                  </TitleLabel>
                  {dataModel.orgOwner.length !== 0 ? (
                     dataModel.orgOwner.map(({ label, value }) => (
                        <div style={{ padding: '0.25rem' }}>
                           <Chip
                              label={label}
                              key={value}
                              style={{ fontSize: '15px' }}
                              onDelete={handleDelete('orgOwner', value)}
                           />
                        </div>
                     ))
                  ) : (
                     <SearchEmployee onChange={handleAdd('orgOwner')} />
                  )}
               </Box>

               {formInformation.typeReward == 'point' && (
                  <Box width={'100%'}>
                     <TitleLabel>
                        หลักเกณฑ์
                        <div className={classes.require}>*</div>
                     </TitleLabel>

                     {surveyDetailInformationData ? (
                        <Input
                           name={'rule'}
                           placeholder='หลักเกณฑ์'
                           value={
                              formInformation.rule.ruleCode &&
                              formInformation.rule.ruleNameTh
                                 ? `${formInformation.rule.ruleCode} : ${formInformation.rule.ruleNameTh}`
                                 : ''
                           }
                           disabled
                        />
                     ) : (
                        <Controller
                           as={<SearchRuleSurvey />}
                           onChange={([selected]) => {
                              handleRule(selected);
                           }}
                           name={'rule'}
                           control={control}
                        />
                     )}
                  </Box>
               )}
            </Box>
            <Box display={'flex'} width={'100%'} gridGap={'16px'}>
               <Box width={'100%'} display={'flex'} alignItems={'flex-end'}>
                  <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                     <TitleLabel>White list ตามสังกัด</TitleLabel>
                     <Box
                        display={'flex'}
                        width={'100%'}
                        style={{ flexWrap: 'wrap' }}
                     >
                        {dataModel.whitelistDivisions &&
                           dataModel.whitelistDivisions.map(
                              ({ label, value }) => (
                                 <div style={{ padding: '0.25rem' }}>
                                    <Chip
                                       label={label}
                                       key={value}
                                       style={{ fontSize: '15px' }}
                                       onDelete={handleDelete(
                                          'whitelistDivisions',
                                          value,
                                       )}
                                    />
                                 </div>
                              ),
                           )}
                     </Box>
                     <SearchDivision
                        onChange={handleAdd('whitelistDivisions')}
                        whitelist={dataModel.whitelistDivisions || []}
                        blacklist={dataModel.blacklistDivisions || []}
                     />
                  </Box>
               </Box>

               <Box width={'100%'} display={'flex'} alignItems={'flex-end'}>
                  <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                     <TitleLabel>Black list ตามสังกัด</TitleLabel>
                     <Box
                        display={'flex'}
                        width={'100%'}
                        style={{ flexWrap: 'wrap' }}
                     >
                        {dataModel.blacklistDivisions &&
                           dataModel.blacklistDivisions.map(
                              ({ label, value }) => (
                                 <div style={{ padding: '0.25rem' }}>
                                    <Chip
                                       label={label}
                                       key={value}
                                       style={{ fontSize: '15px' }}
                                       onDelete={handleDelete(
                                          'blacklistDivisions',
                                          value,
                                       )}
                                    />
                                 </div>
                              ),
                           )}
                     </Box>
                     <SearchDivision
                        onChange={handleAdd('blacklistDivisions')}
                        whitelist={dataModel.whitelistDivisions || []}
                        blacklist={dataModel.blacklistDivisions || []}
                     />
                  </Box>
               </Box>
            </Box>
         </div>

         {/* ระยะเวลากิจกรรม และ เปิด-ปิด กิจกรรม */}
         <div className={classes.type_privilege}>
            <TitleLabel>ระยะเวลาที่จัดกิจกรรม</TitleLabel>
            <Box display={'flex'} flexDirection={'column'}>
               <TitleLabel>Status</TitleLabel>
               <SwitchIOS
                  checked={formInformation.isActive}
                  onChange={handleSurveyChange}
               />

               <Box display={'flex'} gridGap={'10px'} marginTop={'10px'}>
                  <Box width={'100%'}>
                     <TitleLabel>
                        ระยะเวลาที่จัดกิจกรรม
                        <div className={classes.require}>*</div>
                     </TitleLabel>
                     <Box
                        style={{ position: 'relative' }}
                        className={`custom-datepicker`}
                     >
                        <DatePicker
                           className={classes.datePicker}
                           date={selectStartDate}
                           onDateChange={handleStartDateChange}
                           // locale={th}
                           // format="dd MMM yyyy"
                           minimumDate={!surveyGroupId ? new Date() : undefined}
                           locale={enUS}
                        >
                           {({ inputProps, focused }) => (
                              <Box width={'100%'}>
                                 <Input
                                    className={
                                       'input' + (focused ? ' -focused' : '')
                                    }
                                    {...inputProps}
                                    value={`${
                                       inputProps.value &&
                                       dayjs(new Date(inputProps.value)).format(
                                          'DD/MM/BBBB',
                                       )
                                    }`}
                                    width={'52%'}
                                    margin={'0px 3% 0px 0px'}
                                    placeholder={'เลือกวันที่'}
                                    readOnly
                                 />
                                 <Input
                                    className={'input'}
                                    {...timeStartInputProps}
                                    width={'45%'}
                                    type={'time'}
                                 />
                              </Box>
                           )}
                        </DatePicker>
                     </Box>
                  </Box>

                  <Box width={'100%'}>
                     <TitleLabel>&nbsp;</TitleLabel>
                     <Box
                        style={{ position: 'relative' }}
                        className={`custom-datepicker`}
                     >
                        <DatePicker
                           date={selectEndDate}
                           onDateChange={handleEndDateChange('auto')}
                           // locale={th}
                           // format="dd MMM yyyy"
                           locale={enUS}
                           minimumDate={
                              getValues('startDate')
                                 ? getValues('startDate')
                                 : new Date()
                           }
                        >
                           {({ inputProps, focused }) => (
                              <Box width={'100%'}>
                                 <Input
                                    className={
                                       'input' + (focused ? ' -focused' : '')
                                    }
                                    {...inputProps}
                                    value={`${
                                       inputProps.value &&
                                       dayjs(new Date(inputProps.value)).format(
                                          'DD/MM/BBBB',
                                       )
                                    }`}
                                    width={'52%'}
                                    margin={'0px 3% 0px 0px'}
                                    placeholder={'เลือกวันที่'}
                                    readOnly
                                 />

                                 <Input
                                    className={'input'}
                                    {...timeEndInputProps}
                                    width={'45%'}
                                    type={'time'}
                                 />
                              </Box>
                           )}
                        </DatePicker>
                     </Box>
                  </Box>
               </Box>
            </Box>
         </div>

         <div className={classes.type_privilege}>
            <TitleLabel>สถานที่จัดกิจกรรม</TitleLabel>
            <Box display={'flex'}>
               <FormControlLabel
                  style={{ marginLeft: 0 }}
                  control={
                     <Checkbox
                        name={'isUseLocation'}
                        color={'primary'}
                        size={'small'}
                        checked={formInformation.useLocation}
                        onChange={handleUseLocation}
                     />
                  }
                  label={'ระบุสถานที่จัดกิจกรรม'}
               />
            </Box>
            {formInformation.useLocation && (
               <>
                  <Box display={'flex'}>
                     <Box display={'flex'} alignItems={'center'}>
                        <Radio
                           checked={formInformation.useLocationMode === '1'}
                           onChange={handleLocationMode}
                           value='1'
                           name='radio-button-demo'
                        />
                        <Typography>กำหนดจากชื่อสถานที่</Typography>
                     </Box>
                     <Box display={'flex'} alignItems={'center'}>
                        <Radio
                           checked={formInformation.useLocationMode === '2'}
                           onChange={handleLocationMode}
                           value='2'
                           name='radio-button-demo'
                        />
                        <Typography>กำหนดจากละติจูดลองจิจูด</Typography>
                     </Box>

                     {/* <div>{rewardType}</div> */}
                  </Box>
                  {formInformation.useLocationMode === '2' ? (
                     <>
                        <Box display={'flex'} gridGap={'10px'}>
                           <Box width={'25%'}>
                              <TitleLabel>ละติจูด</TitleLabel>
                              <Input
                                 className={'input'}
                                 value={formInformation.latitude}
                                 onChange={handleLatitude}
                              />
                              {!sixDecimalOrIntegerRegex.test(
                                 formInformation.latitude,
                              ) && (
                                 <Typography style={{ color: 'red' }}>
                                    กรุณากรอกทศนิยมอย่างน้อย 6 ตำแหน่ง
                                 </Typography>
                              )}
                           </Box>
                           <Box width={'25%'}>
                              <TitleLabel>ลองจิจูด</TitleLabel>
                              <Input
                                 className={'input'}
                                 value={formInformation.longitude}
                                 onChange={handleLongitude}
                              />
                              {!sixDecimalOrIntegerRegex.test(
                                 formInformation.longitude,
                              ) && (
                                 <Typography style={{ color: 'red' }}>
                                    กรุณากรอกทศนิยมอย่างน้อย 6 ตำแหน่ง
                                 </Typography>
                              )}
                           </Box>
                        </Box>
                     </>
                  ) : formInformation.useLocationMode === '1' ? (
                     <Box display={'flex'} marginTop={'10px'}>
                        <GoogleAddressLookup
                           apiKey={'AIzaSyBao0KGNsTpwLUcPF_0LmklXubqMRSEUME'}
                           onChange={handleLocation}
                           value={formInformation.location}
                           style={{ width: '100%' }}
                        />
                     </Box>
                  ) : (
                     <></>
                  )}
               </>
            )}
         </div>
      </div>
   );
};

export default InformationComponent;
